export enum MetadataType {
    Orphan,
    RO = 1,
    AR = 2,
    Deal = 3,
    DepositLog = 4,
    Vehicle = 5,
    MessageAttachment,
    VoiceTranscription,
    VoiceRecording,
    VendorAttachments,
    Expense,
    ExpenseAttachment,
    PaymentReceipt,
    Temp,
    Appointment,
    Attachment,
    Vendor,
    PartSales = 24,
    WeOwe,
    JobRequisitions = 33,
    ROFollowUp
}

export enum MetadataKeyIdentifier {
    Unknown,
    RepairOrderNumber,
    CustomerNumber,
    DealNumber,
    Id,
    VIN,
    RecordingSid,
    VendorId,
    ExpenseId,
    MessageId,
    CallSid,
    AppointmentNumber,
    AttachmentId,
    InvoiceNumber,
    WeOweNumber
}

export enum TemplateAssociationType {
    Parts = 'Parts',
    Recruiting = 'Recruiting',
    Service = 'Service',
    Customer = 'Customer',
    Vendor = 'Vendor',
    Expense = 'Expense',
    Deal = 'Deal',
    Vehicle = 'Vehicle',
    Deposit = 'Deposit',
    WeOwe = 'WeOwe',
    DealDeal = 'DealDeal',
    Appointment = 'Appointment',
    RO = 'RO',


}

export enum ConversationTypes {
    Text = 1,
    Voice = 2,
    Fax = 3,
    Video = 4,
}
